import { unsafeCSS, html } from "lit";
import { property, state } from "lit/decorators.js";
import { unsafeSVG } from "lit/directives/unsafe-svg.js";
import { cacheFetch } from "../../utilities/cache-fetch.js";
import { watch } from "../../utilities/watch.js";
import { LeafElement } from "../leaf-element.js";
import { LeafIconLibrary } from "./library.js";
const styles = "/*------------------------------------*\\\n#ICON\n\\*------------------------------------*/\n/*------------------------------------*\\\n    #RESET\n\\*------------------------------------*/\n/**\n * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/\n */\n*,\n::slotted(*),\n*:before,\n*:after {\n  box-sizing: border-box;\n}\n\n:host *,\n:host *::before,\n:host *::after {\n  box-sizing: inherit;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n/**\n * 1) Graphic used to supplement text or represent functionality\n */\n:host {\n  display: inline-flex;\n  fill: var(--icon-fill, currentColor);\n  height: var(--icon-height, 1em);\n  width: var(--icon-width, var(--icon-height, 1em));\n  justify-content: center;\n  vertical-align: middle;\n}\n\n.leaf-c-icon {\n  display: block;\n  height: 100%;\n  width: 100%;\n}\n\n:host([size=small]) {\n  --icon-height: var(--leaf-spacing-16);\n  --icon-width: var(--leaf-spacing-16);\n}\n\n:host([size=large]) {\n  --icon-height: var(--leaf-spacing-24);\n  --icon-width: var(--leaf-spacing-24);\n}";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let parser;
const _LeafIcon = class _LeafIcon extends LeafElement {
  constructor() {
    super();
    this.size = "default";
    this.set = "system";
    this.svg = "";
    this.iconSetUpdated = this.iconSetUpdated.bind(this);
  }
  get svgElement() {
    var _a;
    return (_a = this.shadowRoot) == null ? void 0 : _a.querySelector("svg");
  }
  setSVGAttributes(svgElement) {
    const attrs = {
      "aria-hidden": !this.label,
      "aria-label": this.label ? this.label : false,
      class: "leaf-c-icon",
      role: this.label ? "img" : false
    };
    for (const key in attrs) {
      if (attrs[key]) {
        svgElement.setAttribute(key, attrs[key]);
      }
    }
  }
  updateSVGAttributes() {
    if (this.svgElement) {
      this.setSVGAttributes(this.svgElement);
    }
  }
  // eslint-disable-next-line sonarjs/cognitive-complexity
  async fetchIcon(setName, iconName, src) {
    const iconSet = LeafIconLibrary.getInstance().getIconSet(setName);
    const getIconURI = () => iconSet && iconName ? iconSet.getIconURI(iconName) : src;
    const iconURI = getIconURI();
    if (iconURI) {
      const iconHTML = await cacheFetch(iconURI);
      if (iconURI !== getIconURI()) {
        return "";
      }
      if (iconHTML) {
        if (!parser) {
          parser = new DOMParser();
        }
        const dom = parser.parseFromString(iconHTML, "text/html");
        const svgElement = dom.body.querySelector("svg");
        if (svgElement) {
          if (iconSet && iconName) {
            iconSet.mutate(svgElement, iconName);
          }
          this.setSVGAttributes(svgElement);
          return svgElement.outerHTML;
        }
      }
    }
    return "";
  }
  async setIcon() {
    let svg = "";
    try {
      svg = await this.fetchIcon(this.set, this.name, this.src);
      this.emit("leaf:icon-loaded", {
        detail: { set: this.set, name: this.name, src: this.src }
      });
    } catch (error) {
      svg = "";
    }
    if (!svg) {
      this.emit("leaf:error", {
        detail: { set: this.set, name: this.name, src: this.src }
      });
    }
    this.svg = svg;
  }
  iconSetUpdated(event) {
    if (this.set === event.detail.name) {
      this.setIcon();
    }
  }
  firstUpdated() {
    this.setIcon();
  }
  connectedCallback() {
    super.connectedCallback();
    window.addEventListener("leaf:iconset-added", this.iconSetUpdated);
    window.addEventListener("leaf:iconset-removed", this.iconSetUpdated);
  }
  disconnectedCallback() {
    window.removeEventListener("leaf:iconset-added", this.iconSetUpdated);
    window.removeEventListener("leaf:iconset-removed", this.iconSetUpdated);
    super.disconnectedCallback();
  }
  render() {
    return html`${unsafeSVG(this.svg)}`;
  }
};
_LeafIcon.styles = unsafeCSS(styles);
let LeafIcon = _LeafIcon;
__decorateClass([
  property()
], LeafIcon.prototype, "size", 2);
__decorateClass([
  property({ reflect: true })
], LeafIcon.prototype, "set", 2);
__decorateClass([
  property({ reflect: true })
], LeafIcon.prototype, "name", 2);
__decorateClass([
  property()
], LeafIcon.prototype, "src", 2);
__decorateClass([
  property()
], LeafIcon.prototype, "label", 2);
__decorateClass([
  state()
], LeafIcon.prototype, "svg", 2);
__decorateClass([
  watch(["inverted", "label"])
], LeafIcon.prototype, "updateSVGAttributes", 1);
__decorateClass([
  watch(["name", "set", "src"])
], LeafIcon.prototype, "setIcon", 1);
export {
  LeafIcon
};
//# sourceMappingURL=icon.component.js.map
